
// event：
// ================================================================================================
// header：
// 頁面向下時 HEADER縮放
$(window).on('scroll', () => {
    if (window.scrollY > 77) {
        $('.header_bottom').addClass("header_scroll");
        $('.toTop_web').css({ 'opacity': '1' });
    } else {
        $('.header_bottom').removeClass("header_scroll");
        $('.toTop_web').css({ 'opacity': '0' });
    }
});

// header navbar 下滑
$('.navbar_linkdown').on('mouseenter', function (event) {
    $(this).children('.linkdown_event').stop(true, false).slideDown();
});

$('.navbar_linkdown').on('mouseleave', function (event) {
    $(this).children('.linkdown_event').stop(true, false).slideUp();
});


// menu_mobile：
// ================================================================================================
$('.menu_mobile_btn').on('click', () => {
    $('.menu_mobile').css({ 'transform': 'translateX(-100%)' })
    $('.black_bg').css({ 'display': 'block' })
    $('.black_bg , .menu_mobile_close').on('click', () => {
        $('.menu_mobile').css({ 'transform': 'translateX(0%)' })
        $('.black_bg').css({ 'display': 'none' })
    });
});


$('.menu_mobile_downList').on('click', function (event) {
    $(this).next('.downList_link').slideToggle();
});


// navbar_mobile：
// ================================================================================================
// 會員BUTTON
// $('#navbar_member_m').on('click', () => {

//     if (isLogin == true) {
//         // 已經登入
//         window.location.href = "../view/member_center.html";
//     } else {
//         // 未登入
//         window.location.href = "../view/login.html";
//     }
// });

$('#navbar_toTop_m , .toTop_web').on('click', () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});




